import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { CabecalhoModule } from '../../components/cabecalho/cabecalho.module';
import { DescricaoModule } from '../../components/descricao/descricao.module';

import { CaseFinanceiroComponent } from './case-financeiro.component';
import { DetalhesModule } from '../../components/detalhes/detalhes.module';
import { ResultadosModule } from '../../components/resultados/resultados.module';

@NgModule({
  declarations: [
    CaseFinanceiroComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoModule,
    DescricaoModule,
    DetalhesModule,
    ResultadosModule
  ],
  exports: [
    CaseFinanceiroComponent
  ]
})

export class CaseFinanceiroModule { }
